import { updates } from '@/mocks/home';

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            实时快讯
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            最新爆料实时滚动更新，不错过任何一条热点
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-0.5 bg-background-200"></div>

            <div className="space-y-5">
              {updates.map((item) => {
                const tagCls = tagColorMap[item.tagColor] || tagColorMap.primary;
                return (
                  <div key={item.id} className="relative group cursor-pointer">
                    <div className="absolute -left-8 md:-left-10 top-2 w-3.5 h-3.5 md:w-4 md:h-4 rounded-full border-2 border-primary-400 bg-background-50 group-hover:bg-primary-500 group-hover:border-primary-500 transition-colors"></div>
                    <div className="bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 group-hover:border-primary-200/60 transition-colors">
                      <div className="flex items-start gap-3 flex-wrap">
                        <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${tagCls}`}>
                          {item.tag}
                        </span>
                        <h3 className="font-semibold text-foreground-900 text-sm md:text-base leading-snug flex-1 min-w-0 group-hover:text-primary-600 transition-colors">
                          {item.title}
                        </h3>
                        <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}